import { createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "text-snackbar"
};
import { computed } from 'vue';
import { snackbarService } from '@/design/core/composables/useSnackbar';
export default {
  __name: 'Snackbar',
  setup(__props) {
    const snackbarState = snackbarService.state;
    const isVisible = computed({
      get: () => snackbarState.isVisible,
      set: value => {
        snackbarState.isVisible = value;
      }
    });
    const snackbarType = computed(() => snackbarState.type);
    const snackbarText = computed(() => snackbarState.text);
    const snackbarColor = computed(() => {
      if (snackbarType.value === 'error') return 'red';
      if (snackbarType.value === 'alert') return 'warning';
      if (snackbarType.value === 'default' || !snackbarType.value) return 'grey-darken-4';
      return snackbarType.value || undefined;
    });
    const close = () => {
      snackbarService.close();
    };
    return (_ctx, _cache) => {
                                                            
                                                          
                                                                    
      return _openBlock(), _createBlock(_component_v_snackbar, {
        modelValue: isVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isVisible.value = $event),
        class: "snackbar",
        color: snackbarColor.value,
        location: "bottom start",
        "multi-line": true,
        timeout: 8000,
        theme: "dark"
      }, {
        actions: _withCtx(() => [_createVNode(_component_v_btn, {
          variant: "text",
          onClick: close
        }, {
          default: _withCtx(() => [_createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-close", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [snackbarType.value === 'success' ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 0,
          class: "icon",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-checkbox-marked-circle-outline", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), snackbarType.value === 'error' ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 1,
          class: "icon",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("mdi-alert-circle-outline", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), snackbarType.value === 'alert' ? (_openBlock(), _createBlock(_component_v_icon, {
          key: 2,
          class: "icon",
          color: "white"
        }, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("mdi-alert-circle-outline", -1)]))]),
          _: 1
        })) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_1, _toDisplayString(snackbarText.value), 1)]),
        _: 1
      }, 8, ["modelValue", "color"]);
    };
  }
};

/* Vuetify */
import { VBtn as _component_v_btn } from "vuetify/components/VBtn"
import { VIcon as _component_v_icon } from "vuetify/components/VIcon"
import { VSnackbar as _component_v_snackbar } from "vuetify/components/VSnackbar"

